<template>
    <transition :name="$route.meta.transition || 'fade'">
        <div>
            <TickerTape :options="tickerTapeOptions" />

            <div class="container mx-auto py-4">
                <div id="content" class="flex flex-col lg:flex-row lg:divide-x divide-gray-300">
                    <div class="lg:w-3/4 lg:pr-8">
                        <div id="highlights" class="relative">
                            <div class="flex flex-row justify-between mb-3">
                                <strong class="block">
                                    <h1>{{ $t('videos_hkcm') }}</h1>
                                </strong>
                                <div class="flex flex-row gap-4 items-center"></div>
                            </div>

                            <VideoMatrix class="grid grid-cols-1 md:grid-cols-2 mt-6 gap-4" :parameters="{
                                'sort[by]': 'published_at',
                                'sort[order]': 'desc',
                                playlist_id: global ? 'UUvLnTGJQthqju38QPtaD64Q' : ['UU3AdN1bEmEonuSwXNS8LixQ', 'PLsIDvtZfmyZQe9Nmi3sVxwhzn8151Cmpd', 'PLpkkuYdgGRDlrtHT19AX5LSoVSUwLJlkJ'],
                                key: global ? 'UUvLnTGJQthqju38QPtaD64Q' : ['UU3AdN1bEmEonuSwXNS8LixQ', 'PLsIDvtZfmyZQe9Nmi3sVxwhzn8151Cmpd', 'PLpkkuYdgGRDlrtHT19AX5LSoVSUwLJlkJ'],
                                limit: 50,
                                type: ['youtube']
                            }" />
                        </div>
                    </div>

                    <div class="lg:w-1/4 lg:pl-8">
                        <SidebarListWithoutVideo />
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
// HKCM:  UU3AdN1bEmEonuSwXNS8LixQ
// Phantom: PLsIDvtZfmyZQe9Nmi3sVxwhzn8151Cmpd
// HKCM Global:    UUvLnTGJQthqju38QPtaD64Q

import { TickerTape } from 'vue-tradingview-widgets';

export default {
    components: {
        TickerTape
    },
    computed: {
        global() {
            return window.meta.region_configuration.region !== 'de';
        }
    }
};
</script>
